import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';

const Metadata = ({ atType, title, description, noindex, ogImage, customizedTitle, structuredData, data: { siteJson: { meta } } }) => {
  const siteTitle = customizedTitle ? `${title}` : `${title} | 電子豹`;
  const siteOgImage = ogImage ? ogImage : meta.ogImage.publicURL;
  const _structuredData = structuredData;
  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={siteOgImage} />
      { noindex && <meta name="robots" content="noindex"></meta> }
      { _structuredData ? <script type="application/ld+json">
        {`{
          "@context": "https://schema.org",
          "@type": "${atType}",
          "name": "${siteTitle}",
          "description": "${description}",
          ${_structuredData}
        }`}
      </script> :
      <script type="application/ld+json">
        {`{
          "@context": "https://schema.org",
          "@type": "${atType}",
          "name": "${siteTitle}",
          "description": "${description}"
        }`}
      </script>
      }
    </Helmet>
  )
};

Metadata.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  noindex: PropTypes.bool,
  ogImage: PropTypes.string,
  customizedTitle: PropTypes.bool,
  favicon: PropTypes.string,
  atType: PropTypes.string,
  structuredData: PropTypes.string,
  data: PropTypes.shape({
    siteJson: PropTypes.shape({
      meta: PropTypes.shape({
        favicon: PropTypes.shape({
          publicURL: PropTypes.string,
        }),
        ogImage: PropTypes.shape({
          publicURL: PropTypes.string,
        })
      }),
      company: PropTypes.shape({
        logo: PropTypes.shape({
          publicURL: PropTypes.string,
        }),
      }),
    }),
  }),
};
Metadata.defaultProps = {
  title: 'Email 行銷工具',
  description: 'Newsleopard 電子豹',
  customizedTitle: false,
  noindex: false,
};

const SEOComp = props => {
  const data = useStaticQuery(graphql`
    query SiteMetaQuery {
      siteJson {
        meta {
          favicon {
            publicURL
          }
          ogImage {
            publicURL
          }
          keyword
        }
        company {
          logo {
            publicURL
          }
        }
      }
    }
  `)
  return (
    <Metadata data={data} {...props} />
  )
};

export default SEOComp;